<template>
  <div class="areaManage" v-loading="loading" element-loading-text="操作中...">
		<div class="search">
			<span class="title">区域管理</span>
			<div class="flex">
				<el-upload
					class="upload-demo"
					accept=".xls,.xlsx"
					:action="testUrlPath + 'Area/UploadAreaExcel'"
					:limit="1"
					:on-change="(file) => {handleChange(file)}"
					:show-file-list="false"
					:file-list="excelData"
					:headers="headers"
					:on-success="success"
					:on-erroe="error"
				>
					<el-button size="small" type="success" style="margin-top: 20px;">EXCEL导入</el-button>
				</el-upload>
				<el-button type="success" style="margin: 20px 0 0 30px;" size="small" @click="downLoad">下载导入模板</el-button>
			</div>
		</div>
    <div class="content">
			<div class="zhen">
				<h4 class="title1">乡镇(街道)</h4>
				<el-scrollbar style="height: 90%;">
				<ul class="list" v-if="zhen.length>0">
					<el-radio-group v-model="zhenChecked" @change="getCun" style="width: 100%;">
					<li class="item" v-for="(item,index) in zhen" :key="index">
						<el-radio :label="item.id">{{item.name}}</el-radio>
						<i class="el-icon-circle-close" style="cursor: pointer;color: red;" @click="del(1,item.id)"></i>
					</li>
					</el-radio-group>
				</ul>
				<el-empty v-else description="暂无乡镇数据"></el-empty>
				</el-scrollbar>
				<el-button class="btn" type="success" @click="add(1)">新 增</el-button>
			</div>
			<div class="cun">
				<h4 class="title2">村(社区)</h4>
				<el-scrollbar style="height: 90%;">
				<ul class="list" v-if="cun.length>0">
				<el-radio-group v-model="cunChecked" @change="getTun" style="width: 100%;">
					<li class="item" v-for="(item,index) in cun" :key="index">
						<el-radio :label="item.id">{{item.name}}</el-radio>
						<i class="el-icon-circle-close" style="cursor: pointer;color: red;" @click="del(2,item.id)"></i>
					</li>
					</el-radio-group>
				</ul>
				<el-empty v-if="cun.length==0 && zhenChecked" description="该乡镇下暂无村数据"></el-empty>
				</el-scrollbar>
				<el-button class="btn" type="success" @click="add(2)">新 增</el-button>
			</div>
			<div class="tun">
				<h4 class="title3">屯(组)</h4>
				<el-scrollbar style="height: 90%;">
				<ul class="list" v-if="tun.length>0">
					<li class="item" v-for="(item,index) in tun" :key="index">
						<span>{{item.name}}</span>
						<i class="el-icon-circle-close" style="cursor: pointer;color: red;" @click="del(3,item.id)"></i>
					</li>
				</ul>
				<el-empty  v-if="tun.length==0 && cunChecked" description="该村下暂无屯数据"></el-empty>
				</el-scrollbar>
				<el-button class="btn" type="success" @click="add(3)">新 增</el-button>
			</div>
    </div>
		<!-- 新增 -->
		<el-dialog
		  :title="title"
		  :visible.sync="dialogVisible"
		  :close-on-click-modal="false"
			:close-on-press-escape = "false"
			append-to-body
		  :before-close="handleCloseDialog"
			width="50%"
			modal
		>
		 <el-form ref="form" label-width="120px">
		 	<el-form-item label="名称："><el-input v-model="name" style="width: 50%;"></el-input></el-form-item>
		 </el-form>
		  <span slot="footer" class="dialog-footer">
		     <el-button @click="handleCloseDialog">取 消</el-button>
		     <el-button type="success" @click="handConfirm">确 定</el-button>
		   </span>
		</el-dialog>
  </div>
</template>
<script>
import {GetAreaListByPId,Add,DeleArea} from '@/api/area'
import { testUrlPath } from '@/static/utils/lyconfig';
import {DownFiles} from '@/api/file'
export default {
  data() {
    return {
			zhen:[],
			zhenChecked:null,
			cun:[],
			cunChecked:null,
			tun:[],
			title:'新增乡镇',
			dialogVisible:false,
			currentType:1,
			name:'',
			excelData:[],
			headers:{"token":JSON.parse(localStorage.getItem("user-token"))},
			loading:false,
    }
  },
 
  mounted() {
    this.getZhen()
  },
  methods: {
		// 获取所有的乡镇
		getZhen(){
			GetAreaListByPId(0).then(res=>{
				if(res.data.state==1){
					this.zhen = res.data.data
				}
			})
		},
		// 获取当前乡镇下的村
		getCun(){
			GetAreaListByPId(this.zhenChecked).then(res=>{
				if(res.data.state==1){
					this.cun = res.data.data
					this.tun = []
					this.cunChecked = null
				}
			})
		},
		// 获取当前村下的屯
		getTun(){
			GetAreaListByPId(this.cunChecked).then(res=>{
				if(res.data.state==1){
					this.tun = res.data.data
				}
			})
		},
		// 下载导入模板
		downLoad(){
			const that = this
			that.loading = true
			let params = {
				type:3,
				token:JSON.parse(localStorage.getItem("user-token")),
				isWorker:JSON.parse(localStorage.getItem("isWorker"))==true?'1':'2'
			}
			DownFiles(params).then(res=>{
					let blob = new Blob([res.data], { type: "application/vnd.ms-excel" }) // response就是接口返回的文件流
					let objectUrl = URL.createObjectURL(blob)
					const link = document.createElement("a")  // 创建a标签
					link.href = objectUrl
					link.download = "区域模板.xlsx"  // 自定义文件名
					link.click() // 下载文件
					URL.revokeObjectURL(objectUrl)  // 释放内存
					that.loading = false
			})
		},
		// excel上传成功回调
		success(response, file, fileList){
			if(response.state==1){
				this.$message.success(response.msg)
				this.excelData = []
				this.getZhen()
			}else{
				this.$message.error(response.msg)
			}
			
		},
		// excel上传失败回调
		error(){
			this.excelData = []
			this.$message.error('上传失败')
		},
		handleChange(file){
			var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1)
			const extension1 = testmsg === "xls";
			const extension2 = testmsg === "xlsx";
			if (!extension1 && !extension2) {
			  return this.$message.warning("请上传xls或xlsx类型文件!")
			}
		},
		// 取消新增
		handleCloseDialog(){
			this.name = ''
			this.dialogVisible = false
		},
		// 新增
		handConfirm(){
			let params
			if(this.name==''){
				return this.$message.error('请输入名称')
			}
			if(this.currentType==1){
				params = {
					name:this.name,
					pId:0
				}
			}else if (this.currentType==2){
				params = {
					name:this.name,
					pId:this.zhenChecked
				}
			}else{
				params = {
					name:this.name,
					pId:this.cunChecked
				}
			}
			Add(params).then(res=>{
				if(res.data.state==1){
					this.$message.success('添加成功')
					this.handleCloseDialog()
					if(this.currentType==1){
						this.zhen = []
						this.zhenChecked = null
						this.cun = []
						this.cunChecked = null
						this.tun = []
						this.getZhen()
					}else if(this.currentType==2){
						this.cun = []
						this.cunChecked = null
						this.tun = []
						this.getCun()
					}else{
						this.tun = []
						this.getTun()
					}
				}else{
					this.$message.error(res.data.msg)
				}
			})
		},
		// 打开新增框
		add(type){
			this.currentType = type
			if(type==1){
				this.dialogVisible = true
				this.title = '新增乡镇'
			}else if(type==2){
				if(!this.zhenChecked){
					return this.$message.error('请先选择乡镇')
				}
				let obj = this.zhen.find(item=>item.id==this.zhenChecked)
				this.dialogVisible = true
				this.title = `${obj.name}新增村`
			}else{
				if(!this.cunChecked){
					return this.$message.error('请先选择村')
				}
				let obj = this.cun.find(item=>item.id==this.cunChecked)
				this.dialogVisible = true
				this.title = `${obj.name}新增屯`
			}
		},
		// 删除区域
		del(type,id){
			this.$confirm('确定删除？', '提示', {
			  confirmButtonText: '确定',
			  cancelButtonText: '取消',
			  type: 'warning'
			}).then(() => {
			  DeleArea(id).then(res=>{
			  	if(res.data.state==1){
			  		this.$message.success('操作成功')
						if(type==1){
							this.zhen = []
							this.zhenChecked = null
							this.cun = []
							this.cunChecked = null
							this.tun = []
							this.getZhen()
						}else if(type==2){
							this.cun = []
							this.cunChecked = null
							this.tun = []
							this.getCun()
						}else{
							this.tun = []
							this.getTun()
						}
			  	}else{
						this.$message.erroe(res.data.msg)
					}
			  })
			}).catch(()=>{})
		},
  }
}
</script>
<style lang="less" scoped>
.areaManage {
	height: 100%;
	.search {
		padding:0 30px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		.title {
			font-size: 20px;
			font-weight: bold;
		}
		.condition {
			display: flex;
			align-items: center;
			margin-right: 20px;
		}
	}
  .content {
		height: 652px;
		margin: 30px 0 0 30px;
		display: flex;
		align-items: center;
		.zhen,.cun,.tun {
			flex: 1;
			height: 100%;
			position: relative;
			.title1,.title2,.title3 {
				margin: 0!important;
				padding: 15px 0;
				text-align: center;
				color: #fff;
			}
			.title1{
				 background-color: #00a9ed;
			}
			.title2 {
				background-color:  #ec8905;
			}
			.title3 {
				background-color:  #2755a4;
			}
			box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.2);
			transition: all 0.3s ease;
			border-radius: 8px;
			background: #fff;
			transition: all 0.3s ease;
			width: 25%;
			margin-right: 50px;
			.list {
				margin:0!important;
				padding:0!important;
				overflow: hidden;
				.item {
					display: flex;
					align-items: center;
					justify-content: space-between;
					padding: 10px 20px;
					font-size: 18px;
				}
			}
			.btn {
				position: absolute;
				bottom: -50px;
				left: 50%;
				transform: translateX(-50%);
			}
		}
	}
/deep/ .el-radio__label {
	font-size: 18px!important;
}
}
</style>
